import 'babel-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';
import mobile from 'is-mobile';

import './theme/theme/index.css';
import './index.stylus';

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import store from './store';

Vue.use(VueRouter);
Vue.prototype.$store = store;

import Index from './pages/index.vue';
import AoiIndex from './pages/aoi-index.vue';
import Login from './pages/login.vue';
import Msg from './pages/msg.vue';
import Aoi from './pages/aoi.vue';
import Order from './pages/order.vue';
import Invatation from './pages/invitation.vue';
import Stock from './pages/stock.vue';
import StockDetail from './pages/stock-detail.vue';
import Mobile from './pages/mobile.vue';
import Error404 from './pages/error-404.vue';
import User from './pages/user.vue';
// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const routes = [
    { path: '/', component: Index, name: '卫星发现·金融' },
    { path: '/aoiindex', component: AoiIndex, name: '我的地盘' },
    { path: '/login', component: Login, name: 'Login' },
    { path: '/msg', component: Msg, name: '消息' },
    { path: '/aoi', component: Aoi, name: '兴趣区' },
    { path: '/order', component: Order, name: '订单' },
    { path: '/invatation', component: Invatation, name: '邀请' },
    { path: '/stock', component: Stock, name: '我的股票' },
    { path: '/mobile', component: Mobile, name: 'Mobile' },
    { path: '/user', component: User, name: '用户中心' },
    { path: '/404', component: Error404, name: '404' },
    {
        path: '/stock/:code',
        component: StockDetail,
        name: '股票详情',
        props: true,
    },
];

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
    routes, // (缩写) 相当于 routes: routes
});

// Token 验证
router.beforeEach((to, from, next) => {
    if (mobile() && to.name !== 'Mobile') {
        next({ name: 'Mobile' });
        return;
    }

    let TOKEN = store.state.USER.TOKEN;

    // 尝试从 storage 中获取 token
    if (!TOKEN && window.localStorage.user) {
        try {
            const user = JSON.parse(window.localStorage.user);
            if (user.token) {
                TOKEN = user.token;

                store.state.USER.TOKEN = TOKEN;
                user.cellphone && (store.state.USER.CELLPHONE = user.cellphone);
                // app.$store.commit('USER/SET_STATE', {
                //     key: 'TOKEN',
                //     value: user.token,
                // });
            }
        } catch (e) {
            console.log(e);
        }
    }

    // 未登录则自动跳转到登录页
    if (to.name !== 'Login' && !TOKEN) next({ path: '/login' });
    // 登录后自动跳转到首页
    else if (to.name == 'Login' && TOKEN) next({ path: '/' });
    else next();
});

// import Menu from './components/menu.vue';

import App from './App.vue';

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
const app = new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app');
